/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Personas_Description_MaxInputs */



/**
* | output |
* | --- |
* | "Description must be at most {count} characters." |
*
* @param {Personas_Description_MaxInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const personas_description_max = /** @type {((inputs: Personas_Description_MaxInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Personas_Description_MaxInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Beschreibung darf maximal ${i?.count} Zeichen lang sein.`)
	return /** @type {LocalizedString} */ (`Description must be at most ${i?.count} characters.`)
});